/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
    object,
} from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    bannerContainer: {
        display: 'inline-block',
        width: '100%',
        marginBottom: 15,
        padding: '0px 5px',
        '& span': {
            display: 'block',
        },
        '& strong': {
            display: 'block',
        },
        '& a': {
            display: 'block',
            position: 'relative',
            color: theme.palette.colorIconHeader,
            border: `${theme.palette.sympathyAdvisorsBorder} 1px solid`,
            lineHeight: 0,
        },
        '& p': {
            position: 'absolute',
            fontSize: 20,
            textAlign: 'center',
            top: 0,
            lineHeight: 1.2,
            left: 0,
            width: '100%',
        },
        '& img': {
            width: '100%',
        },
    },
    bannerFirst: {
        '& p': {
            padding: '10px 0px 0px 0px',
            fontSize: 27,
        },
        '& $showNowBtn': {
            margin: '10px auto',
        },
        '& img': {
            height: 488,
        },
    },
    bannerSecond: {
        display: 'inline-block',
        '& p': {
            top: 30,
            textAlign: 'left',
            left: '5%',
        },
        '& $showNowBtn': {
            float: 'left',
        },
        '& img': {
            height: 240,
        },
    },
    bannerThird: {
        marginTop: 6,
        display: 'inline-block',
        '& p': {
            top: '18%',
            textAlign: 'right',
            paddingRight: 15,
        },
        '& $showNowBtn': {
            float: 'right',
        },
        '& img': {
            height: 240,
        },
    },
    showNowBtn: {
        color: theme.palette.white,
        width: 155,
        margin: '10px 0',
        display: 'block',
        padding: 3,
        fontSize: 17,
        textAlign: 'center',
        textTransform: 'uppercase',
        backgroundColor: theme.palette.sympathyShowNowButton,
        borderRadius: '0',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: theme.palette.sympathyShowNowButton,
            color: theme.palette.white,
        },
    },
    leftSide: {
        width: '49%',
        display: 'inline-block',
    },
    rightSide: {
        width: '47%',
        display: 'inline-block',
        marginLeft: 25,
    },
});
const ImageUrl = '//cdn1.1800flowers.com/wcsstore/Flowers/images/2018/display/tiles/';

const FlowerGiftsBannerImage = ({ classes }) => (
    <Grid className={classes.bannerContainer}>
        <div className={classes.leftSide}>
            <Link
                to="/flowers-same-day-delivery"
                className={classes.bannerFirst}
            >
                <img src={`${ImageUrl}/sem-tile-fields-of-europe-large.jpg?height=522&width=522`} alt="Best-Selling Flowers & Gifts" />
                <Typography>
                    <span> Brighten Someone&apos;s Day with</span>
                    <strong> Best-Selling Flowers & Gifts</strong>
                    <Button className={classes.showNowBtn}>Show Now</Button>
                </Typography>
            </Link>
        </div>
        <div className={classes.rightSide}>
            <Link
                className={classes.bannerSecond}
                to="/birthdayflowers"
            >
                <img src={`${ImageUrl}/sem-tile-exotic-breeze-orchids-small.jpg?height=257&width=432`} alt="Birthday Surprise" />
                <Typography>
                    <span>There&apos;s a</span>
                    <span>Celebration Behind</span>
                    <span> Every Colorful</span>
                    <strong>Birthday Surprise!</strong>
                    <Button className={classes.showNowBtn}>Show Now</Button>
                </Typography>
            </Link>
            <Link
                className={classes.bannerThird}
                to="/fall"
            >
                <img src={`${ImageUrl}/sem-tile-floral-embrace-small.jpg?height=140&width=432`} alt="Get Well" />
                <Typography>
                    Looking for the
                    <span>Prefect Rx?</span>
                    <strong>Check Out
                        <span>  Our Get Well</span>
                        Collection
                    </strong>
                    <Button className={classes.showNowBtn}>Show Now</Button>
                </Typography>
            </Link>
        </div>
    </Grid>
);

FlowerGiftsBannerImage.propTypes = {
    classes: object.isRequired,
};

export  default withStyles(styles)(FlowerGiftsBannerImage);
